<template>
  <div>
    <v-overlay :value="$storeUniversite.Loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-stepper class="stepper_bourse" v-model="etape">
      <v-row>
        <v-col cols="2" style="align-self: center">
          <v-img
            src="@/assets/UM6PLOGO.png"
            contain
            max-height="25"
            max-width="150"
            class="d-flex justify-start"
          ></v-img>
        </v-col>
        <v-col cols="8">
          <v-alert
            dense
            outlined
            type="error"
            v-model="alert.model"
            transition="scale-transition"
            @click="alert.model = false"
          >
            {{ alert.texte }}
          </v-alert>
        </v-col>
        <v-col cols="2" class="d-flex justify-end" style="display: grid !important">
          <v-btn-toggle class="ml-auto">
            <v-btn @click="ChangerLangue('fr')">
              <v-img
                src="@/assets/france-flag-icon.svg"
                contain
                max-height="25"
              >
              </v-img>
            </v-btn>
            <v-btn @click="ChangerLangue('en')">
              <v-img
                src="@/assets/english-flag-icon.svg"
                contain
                max-height="25"
              ></v-img>
            </v-btn>
          </v-btn-toggle>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3">
          <v-row>
            <v-col cols="12">
              <v-stepper-header id="stepper-header">
                <v-divider></v-divider>
                <v-stepper-step
                  class="cliquable"
                  v-on:click="StepperClick(1)"
                  :complete="etape > 1"
                  step="1"
                  color="secondary">
                  {{ $storeUniversite.label.InformationsPersonnelles }}
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step
                  class="cliquable"
                  v-on:click="StepperClick(2)"
                  :complete="etape > 2"
                  step="2"
                  color="secondary">
                  {{ $storeUniversite.label.Programmes }}
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step
                  class="cliquable"
                  v-on:click="StepperClick(3)"
                  :complete="etape > 3"
                  step="3"
                  color="secondary">
                  {{ $storeUniversite.label.InformationsScolaire }}
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step
                  class="cliquable"
                  v-on:click="StepperClick(4)"
                  :complete="etape > 4"
                  step="4"
                  color="secondary">
                  {{ $storeUniversite.label.InformationAnnexes }}
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step
                  class="cliquable"
                  v-on:click="StepperClick(5)"
                  :complete="etape > 5"
                  step="5"
                  color="secondary">
                  {{ $storeUniversite.label.InformationResume }}
                </v-stepper-step>
                <v-divider></v-divider>
              </v-stepper-header>
            </v-col>
          </v-row>
          <v-row v-if="false">
            <v-col cols="12" v-show="!$storeUniversite.inscription.ReadOnly">
              <v-alert
                border="left"
                colored-border
                color="secondary"
                elevation="1"
                v-show="
                  $storeUniversite.IngenieurSoumission &&
                  $storeUniversite.inscription.NiveauDEtude.indexOf(
                    $storeCatalogue.DataId.ProgrammeIngenieur
                  ) >= 0
                "
              >
                {{ $storeUniversite.label.DateClotureInge }}
                {{ $storeUniversite.IngenieurSoumission }}
              </v-alert>
              <v-alert
                border="left"
                colored-border
                color="secondary"
                elevation="1"
                v-show="
                  $storeUniversite.MasterSoumission &&
                  $storeUniversite.inscription.NiveauDEtude.indexOf(
                    $storeCatalogue.DataId.Master
                  ) >= 0
                "
              >
                {{ $storeUniversite.label.DateClotureMaster }}
                {{ $storeUniversite.MasterSoumission }}
              </v-alert>
              <v-alert
                border="left"
                colored-border
                color="secondary"
                elevation="1"
                v-show="
                  $storeUniversite.ParalleleSoumission &&
                  $storeUniversite.inscription.NiveauDEtude.indexOf(
                    $storeCatalogue.DataId.ProgrammeParallele
                  ) >= 0
                "
              >
                {{ $storeUniversite.label.DateClotureParallele }}
                {{ $storeUniversite.ParalleleSoumission }}
              </v-alert>
              <v-alert
                border="left"
                colored-border
                color="secondary"
                elevation="1"
                v-show="
                  $storeUniversite.PostBacFrSoumission &&
                  $storeUniversite.inscription.NiveauDEtude.indexOf(
                    $storeCatalogue.DataId.PostBac
                  ) >= 0 &&
                  ($storeUniversite.inscription.InfosBac.TypeDeBac ==
                    $storeCatalogue.DataId.TypeBacFrancais ||
                    !$storeUniversite.inscription.InfosBac.TypeDeBac)
                "
              >
                {{ $storeUniversite.label.DateCloturePostBacFr }}
                {{ $storeUniversite.PostBacFrSoumission }}
              </v-alert>
              <v-alert
                border="left"
                colored-border
                color="secondary"
                elevation="1"
                v-show="
                  $storeUniversite.PostBacMaSoumission &&
                  $storeUniversite.inscription.NiveauDEtude.indexOf(
                    $storeCatalogue.DataId.PostBac
                  ) >= 0 &&
                  ($storeUniversite.inscription.InfosBac.TypeDeBac ==
                    $storeCatalogue.DataId.TypeBacMarocain ||
                    !$storeUniversite.inscription.InfosBac.TypeDeBac)
                "
              >
                {{ $storeUniversite.label.DateCloturePostBacMa }}
                {{ $storeUniversite.PostBacMaSoumission }}
              </v-alert>
              <v-alert
                border="left"
                colored-border
                color="secondary"
                elevation="1"
                v-show="
                  $storeUniversite.PostBacAuSoumission &&
                  $storeUniversite.inscription.NiveauDEtude.indexOf(
                    $storeCatalogue.DataId.PostBac
                  ) >= 0 &&
                  ($storeUniversite.inscription.InfosBac.TypeDeBac ==
                    $storeCatalogue.DataId.TypeBacAutre ||
                    !$storeUniversite.inscription.InfosBac.TypeDeBac)
                "
              >
                {{ $storeUniversite.label.DateCloturePostBacAu }}
                {{ $storeUniversite.PostBacAuSoumission }}
              </v-alert>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="content-stepper" cols="12" md="9">
          <v-row class="v-stepper-content-um6p" id="stepper-content-um6p">
            <v-col cols="12">
              <v-stepper-items>
                <v-stepper-content step="1" class="scrollable">
                  <PersonalInfoComponent ref="childInfoPerso" @update:LoadingList="updateSelectedPrograms"/>
                </v-stepper-content>
                <v-stepper-content step="2" class="scrollable">
                  <ProgramComponent ref="childProgramComponent" />
                </v-stepper-content>
                <v-stepper-content step="3" class="scrollable">
                  <SchoolInfoComponent ref="childSchoolInfoComponent" />
                </v-stepper-content>
                <v-stepper-content step="4" class="scrollable">
                  <AnnexeComponent ref="childAnnexe" />
                </v-stepper-content>
                <v-stepper-content step="5" class="scrollable">
                  <RecapComponent ref="childVisionneuseComponent" />
                </v-stepper-content>
                <br/>
                <v-row v-if="etape === '2' && $storeUniversite.ShowBtnMajProgrammes">
                  <v-col class="d-flex justify-center">
                    <v-btn
                    class="btn-responsive"
                    dark
                    color="#004a99"
                    @click="StepperClick(Number(etape))">
                      {{ $storeUniversite.label.MajProgrammes }}
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row> 
                  <v-col class="d-flex justify-end">
                    <v-btn 
                    class="btn-responsive"
                    dark 
                    color="um6p" 
                    @click="Precedent()"
                    v-if="Number(etape) > 1">
                      {{ $storeUniversite.label.Precedent }}
                    </v-btn>
                  </v-col>
                  <v-col class="d-flex justify-start" v-if="Number(etape) < 5">
                    <v-btn
                    class="btn-responsive"
                    dark
                    color="um6p" 
                    @click="StepperClick(Number(etape)+1)">
                      {{ $storeUniversite.label.Suivant }}
                    </v-btn>
                  </v-col>
                  <v-col  class="d-flex justify-start" v-if="etape === '5'">
                    <v-btn
                    class="btn-responsive"
                    dark
                    color="um6p"
                    v-show="!$storeUniversite.inscription.ReadOnly"
                    @click="soumettreForm">
                      {{ $storeUniversite.label.SoumettreCandidature }}
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-snackbar
                      :timeout="2000"
                      color="error"
                      elevation="24"
                      absolute
                      v-model="alert.model"
                    >
                      {{ alert.texte }}
                      <router-link v-if="dynamicLink != null" :to="dynamicLink" class="text-decoration-none">
                        {{ $storeUniversite.label.Ici }}
                      </router-link>
                    </v-snackbar>
                  </v-col>
                </v-row>
              </v-stepper-items>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-stepper>
    <v-dialog v-model="dialogInscription.informations.model" width="500">
      <v-card>
        <v-card-title>Informations</v-card-title>
        <v-card-text>
          <p v-html="dialogInscription.informations.texte"></p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialogInscription.informations.model = false"
          >
            Fermer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PersonalInfoComponent from "@/components/InscriptionUniversite/InformationPersoComponent.vue";
import SchoolInfoComponent from "@/components/InscriptionUniversite/InformationScolaireComponent.vue";
import ProgramComponent from "@/components/InscriptionUniversite/ProgrammesComponent.vue";
import AnnexeComponent from "@/components/InscriptionUniversite/AnnexesInscrUm6pComponent.vue";
import RecapComponent from "@/components/InscriptionUniversite/RecapInscriptionUm6pComponent.vue";

export default {
  data() {
    return {
      autorise : false,
      etape: "1",
      alert:{
        texte : "",
        model:false,
      },
      dialogInscription: {
        informations: {
          model: false,
          texte: null,
        },
      },
      dynamicLink : null,
      //Réafecter objet global
      $storeUniversite: this.$storeUniversite,
      $storeCatalogue: this.$storeCatalogue,
    };
  },
  components: {
    PersonalInfoComponent,
    SchoolInfoComponent,
    ProgramComponent,
    AnnexeComponent,
    RecapComponent,
  },
  name: "InscriptionUniversite",
  methods: {
    async StepperClick(etapeCible){
      this.alert.model = false;
      let nEtapeCible = Number(etapeCible);
      let nThisEtape = Number(this.etape);
      let pjManquantes = false;
      this.$refs.childProgramComponent.AffecterStore();
      // Enregistrer les données
      this.$storeUniversite.Loader = true;

      const reponse = await this.$storeUniversite.InscriptionUm6p("");

      this.$storeUniversite.Loader = false;

      if(reponse === "error" || reponse.status !== 200){
          this.alert.texte = this.$storeUniversite.label.UneErreurEstSurvenue;
          this.alert.model = true;
      }
      else{
        if (reponse.data.message === "pj") {
          pjManquantes = true;
        }
        if(nEtapeCible != nThisEtape){
          this.ValidationEtape(nEtapeCible, nThisEtape, pjManquantes);
        }
        else if(nEtapeCible == 2 && nEtapeCible == nThisEtape && this.$storeUniversite.ShowBtnMajProgrammes){
          this.dialogInscription.informations.texte = this.$storeUniversite.label.SuccesMajProgrammes;
          this.dialogInscription.informations.model = true;
          this.$storeUniversite.ShowBtnMajProgrammes = false;
          this.$storeUniversite.ListeVueProgrammes = reponse.data.listeVueProgrammes;
          this.$refs.childProgramComponent.AffecterVueProgramme();
          if (
            this.$storeUniversite.inscription.Etat == this.$storeCatalogue.DataId.InscriptionR1 ||
            this.$storeUniversite.inscription.Etat == this.$storeCatalogue.DataId.InscriptionR2
          ) {
            this.dynamicLink = "/InscriptionConfirmee";
          } else if (
            this.$storeUniversite.inscription.Etat ==
            this.$storeCatalogue.DataId.InscriptionComplementSoumis
          ) {
            this.dynamicLink = "/InscriptionComplement";
          }
        }
      }
    },
    ValidationEtape(nEtapeCible, nThisEtape, pjManquantes){
      // Si on avance dans les etapes, on vérifie toutes les étapes entre l'etape d'origine et l'étape de destination.
      if (nEtapeCible >= nThisEtape) {

        let blabla = nEtapeCible;
        let texte = "";
        let etapeValide = false;

        for (let i = nThisEtape; i < nEtapeCible; i++) {
          etapeValide = false;
          // =====================

          // Message à afficher
          if (i.toString() === "1") {
            if (this.$refs.childInfoPerso.Valider() === true) {
              etapeValide = true;
            }
            else {
              blabla = i.toString();
              break;
            }
          }
          else if (i.toString() === "2") {
            if (this.$refs.childProgramComponent.Valider() === true) {
              etapeValide = true;
            }
            else {
              texte = this.$storeUniversite.label.ProgrammeMinimum;
              blabla = i.toString();
              break;
            }
          }
          else if (i.toString() === "3") {
            if (this.$refs.childSchoolInfoComponent.Valider() === true) {
              etapeValide = true;
            }
            else {
              blabla = i.toString();
              break;
            }
          }
          else if (i.toString() === "4") {
            // Vérifier si toutes les annexes sont ajoutées.
            if (pjManquantes === false) {
              etapeValide = true;
            }
            else {
              texte = this.$storeUniversite.label.AnnexesManquantes;
              blabla = i.toString();
              break;
            }
          }
          else if (i.toString() === "5") {
            etapeValide = true;
          }
          else {
            blabla = i.toString();
            break;
          }
          // =====================
        }

        if (etapeValide === false) {
          if (texte === "") {
            texte = this.$storeUniversite.label.ChampsObligatoires;
          }
          this.alert.texte = texte;
          this.alert.model = true;
        }
        else {
          window.scrollTo(0, 0);
        }

        this.etape = blabla.toString();
      }
      else {
        this.etape = nEtapeCible.toString();
      }

      // Charger les annexes.
      if (this.etape === "4") {
        this.$refs.childAnnexe.ChargerAnnexesInscription();
      }
    },
    Precedent(){
      this.alert.model = false;
      this.etape--;
    },
    soumettreForm() {
      let self = this;
      let message = null;
      let etatInscription = null;

      Promise.all([
        this.$storeUniversite
          .InscriptionUm6p("submit")
          .then((response) => {
            if (response.data) {
              message = response.data.message;
              etatInscription = response.data.etat;
            }
          })
          .catch((error) => {
            if (error) {
              console.log(error);
              alert(error);
            }
          }),
      ]).then(function () {
        self.$storeUniversite.Loader = false;
        if (message) {
          console.log(message)
        } else {
          if (
            etatInscription == self.$storeCatalogue.DataId.InscriptionR1 ||
            etatInscription == self.$storeCatalogue.DataId.InscriptionR2
          ) {
            self.$router.push("/InscriptionConfirmee");
          } else if (
            etatInscription ==
            self.$storeCatalogue.DataId.InscriptionComplementSoumis
          ) {
            self.$router.push("/InscriptionComplement");
          }
        }
      });
    },

    VerifierEtAffecterVariablesParDefaut() {
      if (!this.$storeUniversite.inscription.Pays) {
        this.$storeUniversite.inscription.Pays =
          this.$storeCatalogue.DataId.Maroc;
      }

      if (!this.$storeUniversite.inscription.InfosMaster.Pays) {
        this.$storeUniversite.inscription.PaysLicence =
          this.$storeCatalogue.DataId.Maroc;
      }

      if (!this.$storeUniversite.inscription.InfosTuteur.Pays) {
        this.$storeUniversite.inscription.PaysTuteur =
          this.$storeCatalogue.DataId.Maroc;
      }

      if (!this.$storeUniversite.inscription.PaysDeNaissance) {
        this.$storeUniversite.inscription.PaysDeNaissance =
          this.$storeCatalogue.DataId.Maroc;
      }

      if (!this.$storeUniversite.inscription.PaysDeResidence) {
        this.$storeUniversite.inscription.PaysDeResidence =
          this.$storeCatalogue.DataId.Maroc;
      }

      if (
        this.$storeUniversite.inscription.NiveauDEtude !==
        this.$storeCatalogue.DataId.PostBac
      ) {
        if (
          !this.$storeUniversite.inscription.InfosMaster
            .VotreDiplomeActuelEnCoursOuObtenu
        ) {
          this.$storeUniversite.inscription.DiplomeActuel =
            this.$storeCatalogue.DataId.BacPlus3;
        }
      }

      if (
        this.$storeUniversite.inscription.InfosBac.TypeDeBac ===
          this.$storeCatalogue.DataId.TypeBacMarocain ||
        (this.$storeUniversite.inscription.InfosBac.TypeDeBac ===
          this.$storeCatalogue.DataId.TypeBacFrancais &&
          this.$storeUniversite.inscription.InfosBac.BaremeDeNotationAuBac ===
            this.$storeCatalogue.DataId.BaremBac20)
      ) {
        this.$storeUniversite.lectureSeuleBarem = true;
      }
    },

    ChangerLangue(langue) {
      // Mettre à jour la langue des rules
      this.$rules.lang = langue
      if (langue === "en") {
        this.$storeUniversite.label = this.$storeUniversite.labelen;
        this.$storeUniversite.itemLang = "lang01";
        this.$StoreAnnexesInscrUm6p.Label = this.$StoreAnnexesInscrUm6p.LabelEN;
        this.$StoreAnnexesInscrUm6p.ItemLang = "Lang01";
      } else {
        this.$storeUniversite.label = this.$storeUniversite.labelfr;
        this.$storeUniversite.itemLang = "lang00";
        this.$StoreAnnexesInscrUm6p.Label = this.$StoreAnnexesInscrUm6p.LabelFR;
        this.$StoreAnnexesInscrUm6p.ItemLang = "Lang00";
      }
    },

    ChangeBaremBac() {
      if (
        this.$storeUniversite.inscription.InfosBac.BaremeDeNotationAuBac !=
        this.$storeCatalogue.DataId.BaremBacAutre
      ) {
        let selectedDiplomeId =
          this.$storeUniversite.inscription.InfosBac.BaremeDeNotationAuBac;
        if (selectedDiplomeId !== null) {
          let selectedDiplome = this.$storeCatalogue.BaremBac.find(
            (d) => d.id === selectedDiplomeId
          );
          this.$storeUniversite.NoteBacMaxAutorise = selectedDiplome.lang00;
        }
      } else {
        this.$storeUniversite.NoteBacMaxAutorise = parseFloat(
          this.$storeUniversite.inscription.InfosBac.SpecificationDuBaremeDeBac
        );
      }
    },
    ChangeBaremMaster() {
      if (
        this.$storeUniversite.inscription.InfosMaster.VotreEchelleDeNotation !=
        this.$storeCatalogue.DataId.BaremBacAutre
      ) {
        let selectedDiplomeId =
          this.$storeUniversite.inscription.InfosMaster.VotreEchelleDeNotation;
        if (selectedDiplomeId !== null) {
          let selectedDiplome = this.$storeCatalogue.BaremBac.find(
            (d) => d.id === selectedDiplomeId
          );
          this.$storeUniversite.NoteBacMaxAutoriseMaster =
            selectedDiplome.lang00;
        }
      } else {
        this.$storeUniversite.NoteBacMaxAutoriseMaster = parseFloat(
          this.$storeUniversite.inscription.InfosMaster
            .VeuillezPreciserVotreEchelleDeNotation
        );
      }
    },
    updateSelectedPrograms() {
      if (this.$storeUniversite.inscription.SportifHautNiveau ===
          this.$storeCatalogue.DataId.Non) {
        // MAJ du isChecked sur le programme sportif
        this.$refs.childProgramComponent.DeselectionnerProgrammeSportif();
      }
    }
  },
  async mounted() {
    this.$storeUniversite.lectureSeule = true;
    let token = this.$route.query.t;
    this.$storeUniversite.Loader = true;
    if (token) {
      this.token = token.replace(/\s/g, "+");
    }
    this.$storeUniversite.Token = this.token;
    this.$refs.childAnnexe.handleResize();
    let inscriptionFileId = null;

    await this.$storeCatalogue.ChargerCataloguesInscriptionUniversite();
    const reponse = await this.$storeUniversite.GetInscriptionExistante(this.token);
    if(reponse !== "error"){
      if(!reponse.autorise){
        this.autorise = false;
        this.$router.push("/NonConnecte");
      }
      else {
        this.autorise = true;
        this.$storeUniversite.MapperInscriptionExistante(
          reponse.inscriptionInfo
        );
        inscriptionFileId = reponse.inscriptionInfo.encryptId;
        this.$storeCatalogue.ChargerListeAnneeBac(this.$storeUniversite.inscription.AnneeScolaire)
        this.$storeUniversite.ListeVueProgrammes = reponse.inscriptionInfo.listeVueProgrammes;
        
        this.$storeUniversite.ShowBtnMajProgrammes = false;
        this.VerifierEtAffecterVariablesParDefaut();
        this.$storeCatalogue.GetVilleMarocFileData();
        if (
          this.$storeUniversite.inscription.InfosBac.TypeDeBac ===
          this.$storeCatalogue.DataId.TypeBacMarocain
        ) {
          this.$storeCatalogue.GetEtablissementsMarocFileData(
            this.$storeUniversite.inscription.InfosBac.VilleDuLycee
          );
        }
        let selectedDiplomeId =
          this.$storeUniversite.inscription.InfosBac.BaremeDeNotationAuBac;
        let selectedDiplomeId2 =
          this.$storeUniversite.inscription.InfosMaster.EchelleNotation;
        if (selectedDiplomeId != null) {
          let selectedDiplome = this.$storeCatalogue.BaremBac.find(
            (d) => d.id === selectedDiplomeId
          );
          this.$storeUniversite.NoteBacMaxAutorise = selectedDiplome.lang00;
        }
        if (selectedDiplomeId2 != null) {
          let selectedDiplome2 = this.$storeCatalogue.BaremBac.find(
            (d) => d.id === selectedDiplomeId2
          );
          this.$storeUniversite.NoteBacMaxAutoriseMaster =
            selectedDiplome2.lang00;
        }
      }
    }

    const reponseParam = await this.$storeUniversite.GetParamInscription(inscriptionFileId);
    if(reponseParam && reponseParam != "error"){
      this.$storeUniversite.MapperParamInscription(reponseParam);
    }

    if(this.autorise){
      this.$storeUniversite.GetNiveauDiplome(this.$storeCatalogue);
      this.$refs.childInfoPerso.$refs.formulaireInfoPerso.resetValidation();
      this.$refs.childProgramComponent.$refs.formulaireProgramme.resetValidation();
      this.$refs.childSchoolInfoComponent.$refs.formulaireInfoScolaire.resetValidation();
      this.$refs.childProgramComponent.ChoixCycleChange();
      this.updateSelectedPrograms();
      this.$refs.childProgramComponent.AffecterVueProgramme();
      this.$storeUniversite.Loader = false;
    }

    this.$storeUniversite.Loader = false;
  },
};
</script>

<style scoped src="@/assets/css/DemandeBourse.css"></style>
<style scoped src="@/assets/css/InscriptionUniversite.css"></style>
